import { client } from "../client";
import { TicketLabel } from "../types/ticket.types";

export const fetchTicketLabels = async ({ all }: { all?: boolean }) => {
    const params = new URLSearchParams();
    if (all === true) {
        params.append('all', 'true')
    }
    const response = await client.get<TicketLabel[]>(`tickets/labels`, { params });
    return response.data
};

export const fetchTicketLabel = async (id: number | string) => {
    if (id == undefined) {
        return null;
    }
    const response = await client.get<TicketLabel>(`tickets/labels/${id}`);
    return response.data
};
